import api from "./api";
import { LinkButton, LinkThreeData, Professional } from "../types";

async function getButtons(id: string | number): Promise<LinkThreeData> {
  try {
    const { data } = await api.get(`/professional-url/${id}/`);

    return data;
  } catch (e) {
    return { buttons: [] };
  }
}

async function putButton(
  id: string | number,
  buttons: LinkButton[],
): Promise<LinkThreeData> {
  try {
    const { data } = await api.put(`/professional-url/${id}/`, buttons);

    return data;
  } catch (e) {
    return { buttons: [] };
  }
}

async function putSave(
  id: string | number,
  body: Partial<Professional>,
): Promise<boolean> {
  try {
    // Usa o endpoint /users/{id}/profile/ que suporta photo_base64 (com barra final)
    await api.put(`/users/${id}/profile/`, body);
    return true;
  } catch (e) {
    console.error("Erro ao salvar perfil:", e);
    return false;
  }
}

async function putColors(
  id: string | number,
  colors: {
    background?: string;
    color?: string;
    color_secondary?: string;
    minha_url?: string | null;
  },
): Promise<{ success: boolean; error?: string }> {
  try {
    await api.put(`/professional-url/colors/${id}/`, colors);
    return { success: true };
  } catch (e: unknown) {
    console.error("Erro ao atualizar cores do LinkThree:", e);
    const error = e as { response?: { data?: { error?: string } } };
    return {
      success: false,
      error:
        error.response?.data?.error ||
        "Erro ao salvar cores e configurações do site de links.",
    };
  }
}

async function scheduleAppointment(
  professionalId: string | number,
  body: {
    first_name: string;
    last_name: string;
    email: string;
    phone?: string;
    date_time: string;
    type: string;
    duration_minutes: number;
  },
): Promise<boolean> {
  try {
    await api.post(`/professional-url/${professionalId}/schedule/`, body);
    return true;
  } catch (e) {
    return false;
  }
}

async function getAvailableSlots(
  professionalId: string | number,
  date: string,
  durationMinutes: number = 30,
): Promise<string[]> {
  try {
    const { data } = await api.get(
      `/professional-url/${professionalId}/available-slots/`,
      {
        params: {
          date,
          duration_minutes: durationMinutes,
        },
      },
    );
    return data.available_slots || [];
  } catch (e) {
    console.error("Erro ao buscar horários disponíveis:", e);
    return [];
  }
}

async function getServices(
  professionalId: string | number,
): Promise<Array<{ id: number; name: string; duration_minutes: number }>> {
  try {
    const { data } = await api.get(
      `/professional-url/${professionalId}/services/`,
    );
    return Array.isArray(data) ? data : [];
  } catch (e) {
    console.error("Erro ao carregar serviços:", e);
    return [];
  }
}

async function completeOnboarding(
  userId: string | number,
): Promise<{ success: boolean; token?: string; error?: string }> {
  try {
    const { data } = await api.post(`/users/${userId}/complete-onboarding/`);
    return { success: true, token: data.token };
  } catch (e: unknown) {
    console.error("Erro ao marcar onboarding como completo:", e);
    const error = e as { response?: { data?: { error?: string } } };
    return {
      success: false,
      error:
        error.response?.data?.error ||
        "Erro ao marcar onboarding como completo.",
    };
  }
}

const linksthree = {
  getButtons,
  putButton,
  putSave,
  putColors,
  scheduleAppointment,
  getAvailableSlots,
  getServices,
  completeOnboarding,
};

export default linksthree;
